import { withInstall } from '@vuemap/vue-amap-util'
import Polyline from './Polyline.vue'

export const ElAmapPolyline = withInstall(Polyline)
export default ElAmapPolyline
